
$(window).load(function() {	


/*menu-list-tab*/
$('.menu_list > li:first-child').addClass('selected');


$('.menu_list li').click(function(e){
  e.preventDefault();
  if (!$(this).hasClass('selected')) {    
	$('.menu_list li').removeClass('selected');
	$(this).addClass('selected');
	$('.menu-boxBody ul.menu-nav').slideUp('1500');
	$('.menu-boxBody ul.menu-nav:eq(' + $('.menu_list > li').index(this) + ')').slideDown('1500');
 }
}).mouseover(function() { 
  $(this).addClass('mouseover');
  $(this).removeClass('mouseout');   
}).mouseout(function() {
  $(this).addClass('mouseout');
  $(this).removeClass('mouseover');    

});
/*dropdown*/
  $(".menu-nav  > li >  span").click(function () {
    if (false == $(this).next().is(':visible')) {
      $('.menu-nav  ul').slideUp();
    }

    var $currIcon=$(this).find("span.the-btn");

    $("span.the-btn").not($currIcon).addClass('fa-plus').removeClass('fa-minus');

    $currIcon.toggleClass('fa-minus fa-plus');

    $(this).next().slideToggle();

    $(".menu-nav  > li > span").removeClass("active");
    $(this).addClass('active');

  });
  
  /*welcome-page*/

$('.welcome_arrow').on('click',function(e){

    e.preventDefault();
    $('.welcome_page').toggleClass('welcome_left');
	  $('.home_slider').toggleClass('home_right');
	$('.welcome_arrow').toggleClass('welcomearrow_left');
	  var $currIcon=$(this).find("span.the-wel");

    $("span.the-wel").not($currIcon).addClass('fa-arrow-right').removeClass('fa-close');

    $currIcon.toggleClass('fa-close fa-arrow-right');

  });
  /*menu*/
  $('.menu-toggle').on('click',function(e){
	  	$('.all_menu').slideToggle();
  });
/*mini-cart*/



    $('.cart').on('click',function(e){
      e.preventDefault();
      $('.minicart').slideToggle();
      
     
    });
   


  
});


